import HeroSection from "./heroSection";
import CardComponent from "./cardComponent";

export default function MainProductsComponent() {


    // TODO: Make pages for each of these
    // https://crisp.chat/en/livechat/livechat-customization/
    let featuresList = [
        {
            id: 2,
            title: "Process refunds instantly with store credit",
            description: "Refund any order in full or in part with store credit. Also supports refunding more than the original amount for a better refund experience.",
            tier: "starter"
        },
        {
            id: 3,
            title: "Gift cards, discount codes, and custom offers",
            description: "Customers can stack store credit with discount codes, gift cards, promotional codes, and custom offers.",
            tier: "starter"
        },
        {
            id: 5,
            title: "Shipping and Sales Tax",
            description: "Customers are able to apply their store credit towards their shipping fees and sales tax during their purchases.",
            tier: "starter"
        },
        {id: 6, title: "Dashboards and granular data tracking", description: "Gain realtime insights with comprehensive dashboards and granular data tracking.", tier: "starter"},
        {
            id: 6,
            title: "All platform support",
            description: "Use Pabloo on your computer or on the go.",
            tier: "starter"
        },
        {
            id: 7,
            title: "Direct integrations for Shopify and WooCommerce",
            description: "Pabloo integrates seamlessly with the leading e-commerce platforms.",
            tier: "starter"
        },
        {
            id: 8,
            title: "Loyalty program for north star metrics",
            description: "The Pabloo loyalty program incentivizes customer sign-ups, referrals, and purchases.",
            tier: "starter"
        },
        {
            id: 9,
            title: "White labeled and customizable",
            description: "Customizable views to perfectly match your shop's theme and branding, ensuring a flawless experience across all devices.",
            tier: "starter"
        },


        {
            id: 1,
            title: "Unlimited deposits, unlimited withdraws",
            description: "Simple, flat-rate pricing. No hidden fees per order.",
            tier: "plus"
        },
        {
            id: 4,
            title: "Credit expiration and product exclusion",
            description: "Maintain control over your store credit program by establishing expiration timelines and defining any product exclusions.",
            tier: "plus"
        },
        {
            id: 12,
            title: "Customer support assistant",
            description: "A dedicated customer support assistant will work closely with you to understand your needs.",
            tier: "plus"
        },

        {
            id: 4,
            title: "Full Checkout Support",
            description: "Supports Shopify Checkout, draft orders, and Wholesale.",
            tier: "plus",
            badge: ""
        },
        {
            id: 14,
            title: "Export data locally",
            description: "All store credit data can be saved locally for further analysis and integration with downstream applications.",
            tier: "plus"
        },  // Exporting customer data
        {
            id: 13,
            title: "Email & SMS notifications",
            description: "Customers are kept informed every time their store credit is added, deducted, or earn cashback.",
            tier: "pro"
        },

        {
            id: 15,
            title: "Revert any completed transaction",
            description: "Handles any error you make when making a deposit or withdraw. Allows you revert store credit changes, including purchases.",
            tier: "plus"
        },
        {
            id: 16,
            title: "Legal currency retailing",
            description: "Your business can legally sell store credit to customers, offering customers flexible payment options and fostering long-term brand engagement.",
            tier: "pro"
        },
        {
            id: 17,
            title: "Opt-in affiliate program",
            description: "Each participating customer has an affiliate link; a portion of each sale generated through the link goes back to the affiliate.",
            tier: "plus"
        },
        {
            id: 18,
            title: "AI Abandoned cart solution (2.5x increase in checkout)",
            description: "Recover lost sales with our AI-powered abandoned cart solution (Boosts checkout rates by 2.3x).",
            tier: "premium"
        },
        {
            id: 19,
            title: "Interactive data with Pabloo AI chat",
            description: "Ask your data anything with our AI assistant.",
            tier: "plus"
        },

        {
            id: 1,
            title: "Unlimited Cashback activities",
            description: "",
            tier: "pro",
            badge: "most_used",
            image: ""
        },
        {
            id: 2,
            title: "Cash App & Venmo Transfers",
            description: "Customers can purchase store credit directly from Cash App or Venmo account.",
            tier: "pro",
            badge: "new"
        },
        {
            id: 5, title: "Recurring Deposits", description: "Customer(s) recieve store credit on a recurring basis.",
            tier: "pro", badge: ""
        },
        {
            id: 6, title: "In-App Chat Support", description: "Get access to 24/7 support chat from within the app.",
            tier: "pro", badge: ""
        },
        {
            id: 8,
            title: "Purchase Triggers",
            description: "Engage with customers that exhibit purchase behavior, and need a little convincing.",
            tier: "pro",
            badge: ""
        },

        {
            id: 20,
            title: "AI tool to reengage dormant customers",
            description: "Analyzes expected Customer Lifetime Value (CLTV) to determine the ideal store credit amount to gift each customer, driving repeat purchases within 60 days and optimizing long-term customer value.",
            tier: "premium"
        },


        // Premium
        {
            id: 1,
            title: "Unlimited Membership subscribers",
            description: "Engage with customers that exhibit purchase behavior, and need a little convincing.",
            tier: "premium",
            badge: ""
        },



        {
            id: 9,
            title: "Templates & Customer Segments",
            description: "Create default templates to use for store credit activities and build customer segments.",
            tier: "plus",
            badge: ""
        },
    ]
    return (
        <div>
            <div>
                <HeroSection/>

                <div id="body" style={{background: "#fff"}}>
                    <div className="">
                        <div className="flex justify-center">
                            <div className="mx-4 md:mx-12 my-20 w-full">
                                <div className="mb-8">
                                    <h2 id="products"
                                        className="font-bold alignleft mb-2 text-4xl md:text-5xl">
                                        12 Major Ways to Use Store Credit
                                    </h2>
                                    <p className="mb-4">
                                        Store credit isn't just for refunds. It's a flexible currency that works across
                                        every part of your business. From keeping customers happy to driving repeat
                                        purchases to rewarding the people who matter most. Here's everything you can do
                                        with store credit.
                                    </p>
                                </div>

                                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">

                                    <CardComponent title="Store Credit E-Wallet"
                                                   ctaURL=""
                                                   blurb="Your own store currency. Issue, manage, and spend store credit without touching the banking system. Comes with a native Shopify interface and a full API for custom builds, so whether you're non-technical or running a custom stack, you're covered."
                                                   imageALT="Pabloo store credit e-wallet dashboard for Shopify merchants"
                                                   imageURL="https://www.networked.co/wp-content/uploads/2023/07/Cover-image-87.png"/>

                                    <CardComponent title="Cashback"
                                                   ctaURL="/products/cashback"
                                                   publishedDate="March 13, 2026"
                                                   blurb="Give every buyer a reason to come back. Automatically reward customers with a percentage of their spend as store credit, a cashback mechanic that feels premium, drives repeat purchases, and keeps revenue in your ecosystem."
                                                   imageALT="Shopify cashback rewards program that gives customers store credit on every purchase"
                                                   imageURL="https://www.networked.co/wp-content/uploads/2023/07/Cover-image-88.png" />

                                    <CardComponent title="Memberships"
                                                   ctaURL="/products/memberships"
                                                   publishedDate="February 9, 2026"
                                                   blurb="Give your best customers something worth paying for. Issue store credit as a membership perk, monthly, quarterly, or on milestones, so members always have a reason to stay subscribed and keep spending with you."
                                                   imageALT="Shopify membership program that rewards subscribers with store credit perks"
                                                   imageURL="https://www.networked.co/wp-content/uploads/2023/07/Cover-image-89.png" />

                                    <CardComponent title="Store Credit CRM" blurb="See exactly who has credit, how much, and what they're doing with it. Segment customers by balance, activity, or redemption behaviour and take action, all from one place. It's your store credit data, finally organized."
                                                   imageALT="Store credit CRM dashboard showing customer balances and redemption activity"
                                                   imageURL="https://images.pexels.com/photos/7709146/pexels-photo-7709146.jpeg" />

                                    <CardComponent title="Refund Facilitation" blurb="Stop letting refunds bleed revenue. When a customer wants to return, offer store credit instead of sending cash out the door. The sale stays on your books, and the customer stays in your store."
                                                   imageALT="Shopify store credit refund tool that keeps revenue in your store instead of issuing cash refunds"
                                                   imageURL="https://images.pexels.com/photos/6684775/pexels-photo-6684775.jpeg" />

                                    <CardComponent title="Reviews, Referrals, and Loyalty Program" blurb="Reward the actions that actually grow your business. Give store credit when customers leave a review, refer a friend, or hit a loyalty milestone. Real incentives that drive real behaviour, without discounting your product."
                                                   imageALT="Shopify loyalty program rewarding customers with store credit for reviews and referrals"
                                                   imageURL="https://www.networked.co/wp-content/uploads/2023/07/Cover-image-20.png" />

                                    <CardComponent title="Scheduled Recurring Store Credit" blurb="Set it and forget it. Automatically drop store credit into customer wallets on whatever cadence works for your business, daily, weekly, monthly, or annually. A simple mechanic that quietly builds habit and keeps customers coming back."
                                                   imageALT="Automated recurring store credit deposits into Shopify customer wallets on a set schedule"
                                                   imageURL="https://images.pexels.com/photos/5053733/pexels-photo-5053733.jpeg" />

                                    <CardComponent title="Paid Ads & Promotional Campaigns" blurb="Run promotions that actually stick. Instead of blanket discounts that train customers to wait for a sale, offer store credit as the reward, it converts browsers into buyers and guarantees they come back to spend it."
                                                   imageALT="Shopify promotional campaign using store credit rewards instead of discount codes"
                                                   imageURL="https://images.pexels.com/photos/907607/pexels-photo-907607.png" />

                                    <CardComponent title="Customer Support and Goodwill Gestures" blurb="Something went wrong, it happens. The fastest way to turn a frustrated customer into a loyal one is to make it right, immediately. Issue store credit on the spot and resolve the situation before it becomes a refund request or a bad review."
                                                   imageALT="Shopify customer support tool for issuing store credit goodwill gestures to resolve complaints"
                                                   imageURL="https://images.pexels.com/photos/5453808/pexels-photo-5453808.jpeg" />

                                    <CardComponent title="Internal Teams Store Credit" blurb="Give your team the ability to spend on your store without the admin overhead. Issue internal store credit for staff perks, allowances, or test purchases, fully tracked, fully controlled, no expense reports needed."
                                                   imageALT="Internal team store credit accounts for staff perks and allowances on Shopify"
                                                   imageURL="https://www.networked.co/wp-content/uploads/2023/07/Cover-image-19.png" />

                                    <CardComponent title="Gift Card / Voucher Programs" blurb="Let customers gift your store to someone else. Issue digital gift cards and vouchers backed by store credit, a clean acquisition channel that brings in new customers who already have money ready to spend."
                                                   imageALT="Shopify digital gift card and voucher program powered by store credit"
                                                   imageURL="https://images.pexels.com/photos/5926415/pexels-photo-5926415.jpeg" />

                                    <CardComponent title="B2B Account Management" blurb="For merchants with business buyers, store credit works like a house account. Pre-load a balance, let them purchase against it, and settle on your terms, no payment friction at checkout, no chasing invoices."
                                                   imageALT="B2B store credit house accounts for Shopify wholesale and business buyers"
                                                   imageURL="https://images.pexels.com/photos/4481262/pexels-photo-4481262.jpeg" />
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <div style={{background: "#014737"}} className="mx-4 md:mx-12 mb-20 rounded-2xl px-10 py-16 flex flex-col items-center text-center">
                    <h2 className="text-white text-4xl md:text-5xl font-bold mb-4 mackinacpro">
                        Your store credit program,<br/>
                        <span style={{color: "#a3e635"}}>live in minutes.</span>
                    </h2>
                    <p className="text-green-200 text-lg mb-10 max-w-xl">
                        Everything on this page is included. No per-transaction fees, no complicated setup.
                    </p>
                    <a
                        href="https://app.pabloo.com/sign-up"
                        className="success-story-button w-inline-block"
                        style={{background: "#fff", color: "#014737", borderRadius: "8px", padding: "14px 32px", fontWeight: 700, fontSize: "18px", textDecoration: "none"}}
                    >
                        Get started for free
                    </a>
                </div>
            </div>
        </div>
    )
}